// extracted by mini-css-extract-plugin
module.exports = {"vin":"CarTitle-vin-1ssOY","action":"CarTitle-action-5geLY"};